module.exports = __webpack_public_path__ + "static/media/letties4-removebg.b9e0ac9d.svg";